module.exports = __webpack_public_path__ + "img/business.d2223017.svg";